import useGoalInfo from '../goal/useGoalInfo';
import useYoutubeChannelTabs from './useYoutubeChannelTabs';
import usePlaylists from './usePlaylists';
import useSinglePlaylists from './useSinglePlaylists';

const useFullYoutubeChannels = (goalUID, fallbackData) => {
  const { key: youtubePlaylistsSWRKey } = usePlaylists(goalUID, {
    fallbackData: fallbackData.playlistsData
  });

  const { key: singleYoutubePlaylistsSWRKey } = useSinglePlaylists(goalUID, {
    fallbackData: fallbackData.singlePlaylists
  });

  const { key: youtubeChannelTabsSWRKey } = useYoutubeChannelTabs(goalUID, {
    fallbackData: fallbackData.channelTabsData
  });

  const { key: goalInfoSWRKey } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalData
  });

  return {
    keys: {
      youtubeChannelTabsSWRKey,
      youtubePlaylistsSWRKey,
      goalInfoSWRKey,
      singleYoutubePlaylistsSWRKey
    }
  };
};

export default useFullYoutubeChannels;
